import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG = "https://images.unsplash.com/photo-1564182998523-6923112e7d6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHx3ZWxkaW5nJTIwc3BhcmtzJTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3ODIzODc3NTF8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const points = [
    "Established in 2014 — over a decade of manufacturing excellence",
    "BIS certified products &amp; ISO certified manufacturing facility",
    "Premium raw materials with strict in-house quality assurance",
    "Trusted by Government &amp; Private Sector customers across India",
  ];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0E1116] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: Text */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-brand-red" />
              <span data-testid="about-eyebrow" className="text-[11px] uppercase tracking-[0.35em] text-brand-red font-medium font-sans">
                About Niryasa Industries
              </span>
            </div>

            <h2
              data-testid="about-heading"
              className="font-display tracking-tight text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] max-w-2xl font-medium"
            >
              Manufacturing <span className="italic text-brand-red font-normal">Excellence</span> <br />
              Since 2014.
            </h2>

            <p
              data-testid="about-description"
              className="mt-8 text-base md:text-lg text-white/65 leading-relaxed max-w-2xl font-sans"
              dangerouslySetInnerHTML={{
                __html: `Niryasa Industries Pvt. Ltd. is a trusted Indian manufacturer specializing in high-quality <span class="text-white font-medium">welding cables</span> and <span class="text-white font-medium">rubber welding hoses</span>. Since our establishment in 2014, we have been committed to delivering products that combine <span class="text-brand-red font-medium">safety, durability, and superior performance</span> for industrial applications.`,
              }}
            />

            <p
              data-testid="about-description-2"
              className="mt-5 text-base text-white/55 leading-relaxed max-w-2xl font-sans"
            >
              Driven by innovation and quality, our manufacturing processes use advanced technology, premium raw materials, and rigorous quality control to ensure every product meets the highest standards.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {points.map((p, i) => (
                <div
                  key={i}
                  data-testid={`about-point-${i}`}
                  className="flex items-start gap-3 border-l-2 border-brand-red/60 pl-4 py-1"
                >
                  <CheckCircle2 size={18} className="text-brand-red mt-1 flex-shrink-0" />
                  <span
                    className="text-sm text-white/80 leading-snug font-sans"
                    dangerouslySetInnerHTML={{ __html: p }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="lg:col-span-5 relative corner-accent">
            <div className="relative aspect-[4/5] overflow-hidden bg-black">
              <img
                src={ABOUT_IMG}
                alt="Manufacturing welding cables"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-transparent" />
            </div>

            {/* Floating data badge */}
            <div
              data-testid="about-badge"
              className="absolute -bottom-6 -left-6 md:-left-10 bg-brand-red text-white p-6 max-w-[240px]"
            >
              <div className="font-display italic text-4xl font-medium leading-none">2014</div>
              <div className="mt-2 text-[10px] uppercase tracking-[0.3em] opacity-90 font-sans">
                Established • Made in India
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
